<script>
  import { Option } from 'element-ui'
  export default {
    name:'ElOption',
    extends:Option
  }
</script>
